export const talentSearchTypes = {
    SET_PERFORMANCE_FILTER: 'TALENT_SEARCH_SET_PERFORMANCE_FILTER',
    SET_PERFORMANCE_GROUP_FILTERS: 'TALENT_SEARCH_SET_PERFORMANCE_GROUP_FILTERS',
    SET_PERFORMANCE_FILTERS: 'TALENT_SEARCH_SET_PERFORMANCE_FILTERS',
    INIT_FILTERS: 'TALENT_SEARCH_INIT_FILTERS',
    CLEAR_FILTERS: 'TALENT_SEARCH_CLEAR_FILTERS',

    SET_SEASONS_FILTER: 'TALENT_SEARCH_SET_SEASONS_FILTER',
    SET_COMPETITIONS_FILTER: 'TALENT_SEARCH_SET_COMPETITIONS_FILTER',

    TOGGLE_SELECT_PLAYER: 'TALENT_SEARCH_TOGGLE_SELECT_PLAYER',
    SET_PAGINATION: 'TALENT_SEARCH_SET_PAGINATION',

    SET_SEARCH_VALUE: 'TALENT_SEARCH_SET_SEARCH_VALUE',
    SET_TEMP_SEARCH_VALUE: 'TALENT_SEARCH_SET_TEMP_SEARCH_VALUE',

    SET_EXPAND_ROW: 'TALENT_SEARCH_SET_EXPAND_ROW',

    SET_REGIONS_FILTER: 'TALENT_SEARCH_SET_REGIONS_FILTER',
    SET_COUNTRIES_FILTER: 'TALENT_SEARCH_SET_COUNTRIES_FILTER',

    SET_SORT: 'TALENT_SEARCH_SET_SORT',

};
